module.exports = __webpack_public_path__ + "static/media/playV2.cc4f975a.svg";